export const LOW_BIT_2MBPS = 2030000;
